// Third-party packages
import {
	RefObject,
} from 'react';
import {
	withTranslation,
} from 'react-i18next';
import {
	useSelector,
} from 'react-redux';
import {
	Outlet,
	useParams,
} from 'react-router-dom';

// Project modules
import {
	useCompanyDetails,
} from '@hooks/useCompany';
import {
	CompanyPageResult,
} from '@localTypes/company';
import {
	DeviceDisplays,
	DeviceOrientations,
} from '@stores/_slices/device';
import {
	ReducerInstance,
} from '@stores/lpdipro/reducers';
import {
	selectUserToken,
} from '@stores/selectors/userSelectors';

// Templates / Layouts / Pages
import {
	Page,
} from '@layouts/Pages/Page';

// Style imports
import styles from './PageCompany.module.scss';

export interface PageCompanyOutletContextType {
	accessToken: string;
	companyDetails: CompanyPageResult;
	companyId: number;
	contentCompanyRef: RefObject<HTMLDivElement>;
	isDesktopResolution: boolean;
	isLoadingCompanyDetails: boolean;
	isNavOpen: boolean;
}

export const PageCompany = withTranslation()(() => {
	const accessToken = useSelector(selectUserToken)!;

	const device = useSelector((state: ReducerInstance) => state.device?.instance);
	const isDesktopResolution = device?.display === DeviceDisplays.DESKTOP || (device?.display === DeviceDisplays.TABLET && device?.orientation === DeviceOrientations.LANDSCAPE);

	const {
		companyid,
	} = useParams();
	const companyId = !isNaN(Number(companyid)) ? Number(companyid) : undefined;

	useCompanyDetails({
		accessToken,
		companyId: companyId!,
	});

	return (
		<Page className={styles.PageCompany} >
			<div
				className={styles.PageCompany__content}
			>
				<Outlet
					context={{
						companyId,
						isDesktopResolution,
					}}
				/>
			</div>
		</Page>
	);
});
